import React from 'react'
import { FaInfoCircle, FiInfo } from '@fareye/utils'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'

export const InfoIconContainer = styled(FaInfoCircle)`
  margin-bottom: -2px;
  height: 14px;
  width: 14px;
  ${(props: any) => `
    background: transparent;
    color: ${props.theme.colors.gray6};
  `}
`
export const ReactTooltipContainer = styled(ReactTooltip)`
  max-width: 150px;
`
export const InfoIconSearchContainer = styled(FiInfo)`
  margin-bottom: -2px;
  height: 14px;
`

export const ReactTooltipSearchContainer = styled(ReactTooltip)`
  &.type-dark.place-top {
    background-color: rgba(255, 255, 255, 1);
    color: black;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    &:after {
      border-top-color: rgba(255, 255, 255, 1);
    }
  }
`

export function InfoIcon(props: any) {
  const { title, ...rest } = props
  return (
    <>
      <InfoIconContainer {...rest} data-tip={props.title} />
      <ReactTooltipContainer />
    </>
  )
}

export function InfoIconSearch(props: any) {
  const { title, ...rest } = props
  return (
    <>
      <InfoIconSearchContainer {...rest} data-tip={props.title} />
      <ReactTooltipSearchContainer />
    </>
  )
}
